module.exports = __webpack_public_path__ + "static/media/icon_product_automotive_parts.2e0bd2ad.svg";